import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormRichText from '../../../../library/form/components/FormRichText';
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle';
import { UiGridColTwo, UiCol, UiRow, UiClear } from "../../../../library/layout/Index";

const StockCheckHeaderEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;

    if (!viewData)
        return (null)

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '220px', overflowY: 'scroll' }}
            formStyle={{ width: '660px', height: '400px' }} formTitle={<FormTitle formObject={formObject} masterKeys={masterKeys} />}
        >
            <UiGridColTwo>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "targetDocType" }} value="Target Document" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", actionId:'refresh', 
                                paramName: "targetDocType", acMethod: "QCDocuments",
                                actionParam: { updateTarget: "1" } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "location" }} value="Location" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "location", acMethod: "StockCheckLocation",
                                    acDepCtrl: { dparam: "%dataList.stockCheckTypeId" } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "inchargeUser" }} value="Incharge User" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "inchargeUser", acMethod: "UserNames" }} />
                        </li>
                    </ul>
                </UiCol>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "requestDate" }} value="Request Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "dp", paramName: "requestDate" }} />
                        </li>
                    </ul>
                </UiCol>
            </UiGridColTwo>
            <UiClear></UiClear>
                <UiRow>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Comments" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" className="uiFrmText" rows="3" cols="82"
                        action={{ paramName: "comment" }}
                    />
                </UiRow>
        </FormDialog>
    )
}

export default withView(StockCheckHeaderEditor, "stockCheckHeader", "stockCheckHeader,stockCheckCriteria,stockCheckListPhysical")
